export const convertToFormData = (jobCardFullData, jobCardSmallData) => {
  const [salary_min, salary_max] = jobCardFullData?.salary_text?.replaceAll('₹', '').split('-')

  const mobile_no = jobCardFullData?.mobile_no
  const whatsapp_no = jobCardFullData?.whatsapp_no || ''
  const email = JSON.parse(localStorage.getItem('lokal_advertiser_profile'))?.email_id;

  const result = {
    openings_count: jobCardFullData?.openings_count,
    platform: 'web',
    is_whatsapp_number: mobile_no === whatsapp_no,
    mobile_no: jobCardFullData?.mobile_no || '',
    job_type: jobCardFullData?.job_type?.id,
    salary_max: Number(salary_max.trim()),
    salary_min: Number(salary_min.trim()),
    shift_timing: jobCardFullData?.shift_timing?.id,
    id: jobCardSmallData?.id,
    title: jobCardSmallData?.title || '',
    source: 'websubmission',
    company_name: jobCardFullData?.company_name || '',
    poster_role: jobCardFullData?.poster_role?.id,
    contact_preference: jobCardFullData?.contact_preference === 'CALLS' ? 0 : jobCardFullData?.contact_preference === 'APPLY' ? 2 : 1,
    agency_name: jobCardFullData?.agency_name || '',
    whatsapp_no,
    fee_amount: jobCardFullData?.fee_amount,
    fee_reason: jobCardFullData?.fee_reason,
    fee_reason_other: jobCardFullData?.fee_reason_other,
    fee_collected_at: jobCardFullData?.fee_collected_at,
    other_details: jobCardFullData?.other_details || '',
    which_kind: jobCardFullData?.which_kind,
    status: jobCardSmallData?.status,
    submitted_on: jobCardSmallData?.submitted_on || '',
    reviewer: jobCardFullData?.reviewer,
    custom_message: jobCardSmallData?.custom_message || '',
    put_in_review: jobCardFullData?.put_in_review,
    finalised_on: jobCardSmallData?.finalised_on || '',
    exotel_last_call_sid: jobCardFullData?.exotel_last_call_sid,
    exotel_total_calls: jobCardFullData?.exotel_total_calls,
    exotel_total_completed_calls: jobCardFullData?.exotel_total_completed_calls,
    exotel_last_call_status: jobCardFullData?.exotel_last_call_status,
    sales_call_status: jobCardFullData?.sales_call_status,
    category: jobCardSmallData?.category,
    job_category: jobCardFullData?.job_category?.id,
    primary_job_role: jobCardFullData?.primary_job_role?.id,
    job_hours: jobCardFullData?.job_hours?.id,
    experience: jobCardFullData?.experience?.id,
    qualification: jobCardFullData?.qualification?.id,
    preferred_gender: jobCardFullData?.preferred_gender?.id,
    preferred_location: jobCardFullData?.preferred_location?.id,
    fees_charged: jobCardFullData?.fees_charged?.id,
    job_location_city: jobCardFullData?.city_location?.id,
    title: jobCardFullData?.title,
    job_location_title:  jobCardFullData?.city_location?.title,
    location: jobCardFullData?.location,
    city_location: jobCardFullData?.city_location,
    city_list: [jobCardFullData?.city_location],
    constituency: jobCardFullData?.job_city,
    advertiser: jobCardFullData?.advertiser,
    classified: jobCardSmallData?.classified,
    user_message: jobCardFullData?.user_message,
    posting_locations: jobCardFullData?.posting_locations || [],
    log_url:
      jobCardSmallData?.attachments?.length > 0 ? jobCardSmallData?.attachments[0]['file'] : '',
    isLogoPresent: jobCardSmallData?.attachments?.length > 0,
    advertiser_company_name : jobCardFullData?.advertiser_company_name,
    company_type : jobCardFullData?.company_type,
    company_size : jobCardFullData?.company_size,
    is_consultancy_name : jobCardFullData?.is_consultancy_name,
    fees_yes_no : jobCardFullData?.fees_charged?.title,
    job_district: jobCardFullData?.location?.id,
    company_email: email
  }

  return result
}
